import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SignUp from './Pages/SignUp';
import Login from './Pages/Login';
import Home from './Pages/Home';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AllCoursePage from './Pages/AllCoursePage';
import CourseDetails from './Pages/CourseDetail';
import MyCourses from './Pages/MyCourses';
import MyCourseView from './Pages/MyCourseView';
import IndustrySpecific from './Pages/IndustrySpecific';
import PartnerCourse from './Pages/PartnerCourse';
import ReferAndEarn from './Pages/ReferAndEarn';
import { CartProvider } from './context/CardContext';
import Cart from './Pages/Cart';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import RefundPolicy from './Pages/RefundPolicy';
import TermsAndConditions from './Pages/TermsAndConditions';
import ContactUs from './Pages/ContactUs';
import StudentProfile from './Pages/StudentProfile';
import LiveClasses from './Pages/LiveClasses';
import StartExam from './Pages/StartExam';
import StudentExams from './Pages/StudentExams';
import VideoPlayerTest from './Pages/VideoPlayerTest';
import MyFeedback from './Pages/MyFeedback';
import Tni from './Pages/Tni';
import ResetPassword from './Pages/ResetPassword';
import NewPassword from './Pages/NewPassowrd';
import VerifyCertificate from './Pages/VerifyCertificate';
import AboutUs from './Pages/Aboutus';
import FAQPage from './Pages/FAQ';
import PlacementPage from './Pages/PlacementPage';
import AnalyticsListener from './AnalyticsListener';
import TataLogin from './Pages/TataLogin';
function App() {
  return (
    <>
      <CartProvider>
        <BrowserRouter>
          <AnalyticsListener />
          <Routes>
            <Route path="*" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/tataloginStudent" element={<TataLogin />} />
            <Route path="/MyExam-login" element={<TataLogin />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/allCourses/:type" element={<AllCoursePage />} />
            <Route path="/courseDetails/:id" element={<CourseDetails />} />
            <Route path="/myCourses" element={<MyCourses />} />
            <Route path="/course/:id" element={<MyCourseView />} />
            <Route path="/industry-specific-course" element={<IndustrySpecific />} />
            <Route path="/partner-course" element={<PartnerCourse />} />
            <Route path="/tni" element={<Tni />} />
            <Route path="/refer-earn" element={<ReferAndEarn />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/placement" element={<PlacementPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/profile" element={<StudentProfile />} />
            <Route path="/live-classes" element={<LiveClasses />} />
            <Route path="/myExams" element={<StudentExams />} />
            <Route path="/myFeedbacks" element={<MyFeedback />} />
            {/* <Route path="/exam-permission/:id" element={<PermissionRequestPage />} /> */}
            {/* <Route path="/exam-permission/:examId" element={<ExamSetup />} />
            <Route path="/exam/:examId/instructions" element={<ExamInstructions />} />
            <Route path="/exam/:examId/attempt" element={<ExamAttempt />} /> */}
            <Route path="/exam/:examId/attempt" element={<StartExam />} />
            <Route path="/player-test" element={<VideoPlayerTest />} />
            <Route path="/forgot-password" element={<ResetPassword />} />
            <Route path="/reset-password" element={<NewPassword />} />
            <Route path="/verify/:certNumber" element={<VerifyCertificate />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
      <ToastContainer />
    </>
  );
}

export default App;
